//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Epk.WebControls.KPosouzeni.ts						</Name>
//    <Description> Dialog - K posouzení										</Description>
//    <Author>      thazmuka													</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018							</Copyright>
//    <Created>     2018-10-02													</Created>
//  </FileHeader>

namespace Gordic.Epk.WebControls {

	const { gcontent } = Decorators;

	/**
	 * EPK - řízení zaškrtávátka 'Čekat na vyřízení' na okně předání k posouzení (enum)
	 */
	export enum EpkZaskceknavyEnum {
		HodnotaNaposledyZvolenaUzivatelem = 0,
		Nezaskrtnuto = 1,
		Zaskrtnuto = 2
	}

	interface IKPosouzeniData {
		CekatNaVyrizeni: boolean,
		IxsFunList: string[] | null,
		TxtDuvod: string | null,
		Color: string | null,
		Termin?: Date| null
    }

	/** K vyřízení */
	@gcontent
	export class KPosouzeni extends GContentBase {

		private checkWait = "CekatNaVyrizeni";
		private form: JQuery<HTMLElement>;
		/** EPK - řízení zaškrtávátka 'Čekat na vyřízení' na okně předání k posouzení */
		private EpZaskceknavy: EpkZaskceknavyEnum;
		/** FilterPridruzenaStrediska */
		private FilterPridruzenaStrediska: boolean;
		/** FilterDlePovolenychFazi */
		private FilterDlePovolenychFazi: string[];
		/** návratový příznak */
		private closeState: boolean = false;
        /** data řádku */
		private Rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[];

        public onContentReady() {
			this.init();
		}

		private init() {
			this.createForm();
			this.createCommandbar();
			this.setCheckBoxWaitForSettlement();
		}

		/**
		* metoda, která zvaliduje formulář a vrátí výsledek validace až je formulář připraven
		* 
		* @param {JQuery<HTMLElement>} form předaný element formuláře
		* @returns {JQueryPromise<boolean>} výsledek stavu
		*/
		private waitForValues(form: JQuery<HTMLElement>): JQueryPromise<boolean> {

			var dfd = $.Deferred();

			form.gform("waitForValues")
				.then(() => {
					return form.gform("isValid");
				})
				.then((isValid) => {
					dfd.resolve(isValid);
				})
				.fail(() => {
					dfd.reject(false);
				})

			return dfd.promise();
		}

		private FunkceHromadnePredani?: string[];
		/** Název seznamu funkcí zobrazený v EPK při hromadném předání k posouzení 
		 * - vyplnění značí aktivaci parametru
		 */ 
		private epk_hrpo_na: string;

		/**
		 * vrátí všechny výchozí filtry políčka vyřizovatele
		 * @param enableHrpo
		 */
		private getServerFilters(enableHrpo: boolean) {
			var serverFilters: any = {
				aktivita: [100],
				DlePovolenychFazi: this.FilterDlePovolenychFazi,
				PridruzenaStrediska: this.FilterPridruzenaStrediska
			};
			//#region -- SPECIÁLNÍ TYP HROMADNÉHO PŘEDÁNÍ K POSOUZENÍ PRO OBRANU --
			// thazmuka (16.7.2021)
			// není vzetí na vědomí (1.10.2021)
			if (enableHrpo === true && this.epk_hrpo_na !== "" && (this.Rows != null && this.Rows[0].typ_pozad_pod !== 50)) {
				if (this.FunkceHromadnePredani != null && this.FunkceHromadnePredani.length > 0)
					serverFilters["ixs_fun"] = this.FunkceHromadnePredani;
			}
			//#endregion
			return serverFilters;
		}

		/**
		 * nastavení filtry políčka vyřizovatele
		 * @param enableHrpo
		 */
		private setServerFilters(enableHrpo: boolean) {
			var element = this.findFields("IxsFunList");
			element.gfield("clear");	// ošetření proti kombinaci fun míst
			element.gfield("option", {
				serverFilters: this.getServerFilters(enableHrpo)
			});
		}

		private createForm(): void {

			this.form = $("<div class='form_kposouzeni_class'>").appendTo(this.element);
			let Form = new Gordic.Forms.Form({
				name: "FormKPosouzeni",
				layoutDescriptor: "L1M1S1, L-2-6-4, M-4-8-0, S-12-12-0"
			});

			Form
				.addSection("jres:26265023") //RC 26265023 : Vyřizuje

			// SPECIÁLNÍ TYP HROMADNÉHO PŘEDÁNÍ K POSOUZEZNÍ PRO OBRANU
			// thazmuka (19.7.2021) 
			// není vzetí na vědomí (1.10.2021)
			if (this.epk_hrpo_na !== "" && (this.Rows != null && this.Rows[0].typ_pozad_pod !== 50)) {
				Form
					.addRow("")
					.addField("gradio", {
						initialValue: 'b',
						radios: [
							{ value: 'a', label: 'jres:32000768' }, //RC 32000768 : Výchozí
							{ value: 'b', label: this.epk_hrpo_na }
						],
						name: "",
						change: (ev, obj) => {
							var value = obj.value === "b" ? true : false;
							this.setServerFilters(value);
						}
					})
			}

			var serverFilters = this.getServerFilters(true);
			var IxsFunListLabel = "jres:26265023"; //RC 26265023 : Vyřizuje

			Form
				.addRow(IxsFunListLabel)			
				.addField("gselectbox", "w-12", (Gordic as any).Gin.Fields.ginsfunSSU({
					validators: [new Gordic.Validators.Required()],
					name: "IxsFunList",
					model: "model.IxsFunList=value.ixs_fun",
					serverFilters: serverFilters,
					multi: true,
					change: (ev, obj) => {
						if (obj.value == null) {
							if (this.actions.actOk != null)
								this.actions.actOk.update({ enabled: false });
                        }
						else {
							if (this.actions.actOk != null)
								this.actions.actOk.update({ enabled: true });
						}
					}
				}, false))

			Form
				.addSection("Další parametry")

			Form
				.addRow("jres:32000707") //RC 32000707 : Termín
				.addField("gdatebox", {
					name: "Termin",
					valueType: "datetime"
                })

			Form
				.addRow()
				.addField("gcheck", {
					disabled: true,
					name: this.checkWait,
					label: "jres:32000102"			//RC 32000102 : Čekat na vyřízení
				})

			Form
				.addRow("jres:32000042")			//RC 32000042 : Upřesnění
				.addField("gstringbox", {
					name: "TxtDuvod",
					rows: 5
				})

			Form
				.addRow({
					label: "jres:32000706"		//RC 32000706 : Barevné označení
				})
				.addField("gcolorpickerfield", {
					name: "Color",
					uzo: Gordic.Widget.GColorPicker.UzoEnum.White,
					model: "model.Color=value",
					type: "epk",
					globalSettings: this.globalSettings
				});

			this.form.gform("createFrom", Form);
		}

		private createCommandbar() {
			var params: MenuParams[] = [];
			params.push({
				favorite: true,
				action: new GAction({
					caption: "jres:32000660", //RC 32000660 : Zavřít
					name: "actZrusit",
					run: () => {
						this.tryClose();
					}
				})
			});
			params.push({
				primary: true,
				favorite: true,
				action: new GAction({
					caption: "jres:32000659", //RC 32000659 : OK
					name: "actOk",
					run: () => {
						this.waitForValues(this.form)
							.then((isValid) => {
								if (isValid === true) {
									var data: IKPosouzeniData = { CekatNaVyrizeni: false, IxsFunList: null, TxtDuvod: null, Color: null, Termin: null };
									this.form.findFields().gfield("model", "collect", data);
									this.clickOnOk(data);
                                }
                            })
					}
				})
			});
            this.commandBar(params);
		}

		private clickOnOk(data: IKPosouzeniData) {

			this.hideFlash("idKPosouzeniDlgFlash");
			this.beginOperation("jres:32000213") //RC 32000213 : Probíhá proces předání k posouzení.

			this.call("KPosouzeniOk", {
				CekatNaVyrizeni: data.CekatNaVyrizeni,
				IxsFunList: data.IxsFunList,
				TxtDuvod: data.TxtDuvod,
				Color: data.Color,
				Termin: data.Termin
			}).then((value: string | null) => {

				if (value == null) {
					if (this.userSettings != null)
						this.userSettings.set("epk.kposouzeni.checkbox", value);					// uložení hodnoty do gstoru

					this.closeState = true;
					this.tryClose();

					for (var x = 0; x < this.Rows.length; x++) {
						this.sendNotificationVyrizeni(this.Rows[x]);
                    }

				}
				else {

					this.showFlash({
						id: "idKPosouzeniDlgFlash",
						content: value,
						state: "error"
					});
                }
			})
				.done(() => {
					this.endOperation();
                })
        }

        /**
		 * poslat notifikace po předání k posouzeni
		 */
		private sendNotificationVyrizeni(dto: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {

            /** zpráva notifikace */
			var txt = "jres:32000366 "; //RC 32000366 : Dokument

			if (dto.typ_pozad_pod === 50)
				txt = txt + dto.ixp! + " jres:32000784."; //RC 32000784 : byl úspěšně dán na vědomí
			else
				txt = txt + dto.ixp! + " jres:32000411."; //RC 32000411 : byl úspěšně předán k posouzení

            setTimeout(() => {
                $.content($(".gcontent")).notification("add", {
                    state: "success",
                    group: "jres:32000132", //RC 32000132 : Událost
                    title: "jres:32000133", //RC 32000133 : Upozornění
                    icon: "gi-tick g-state-text g-state-success",
                    content: txt,
                    dateTime: new Date(),
                    defaultAction: new GAction({
                        name: "showActNoficationDetail",
						run: (ev, ctx) => {

                            var options = {
								Ixp: dto.ixp!,
                                CelyUrad: false,
								SerCislo: dto.ser_cislo!,
                            };
                            Gordic.Epk.Dialogs.DetailZadostiDlg($.content(), options, Gordic.Gin.Globals.Enums.ModOtevreni.navigate);
                        }
                    })
                });
            }, 500);
        }

		closing() {
			return this.closeState;
		}

		/**
		 * nastavit checkbox čekat na vyřízení
		 */
		private setCheckBoxWaitForSettlement() {

			var checkWaitState = true;
			for (var index = 0; index < this.Rows.length; index++) {
				var row = this.Rows[index];
				if (row.sch_pov === 0) {			//nepovinny ukon - 17.10.2019 - nemela by byt moznost cekat (jako povinny). Pokud by se nasledny povinny ukon vyridil negatovne, tak by shodil cely proces, i kdyz uz predchozi byl nepovinny [INC-53560-19]
					checkWaitState = false;
					break;
                }
			}

			var fields = this.form.findFields(this.checkWait);

			if (checkWaitState === false) {
				fields.gfield("setValue", false);
				fields.gfield("disable");
				return;
            }
			else {
				this.form.findFields(this.checkWait).gfield("enable");
				if (this.EpZaskceknavy === EpkZaskceknavyEnum.HodnotaNaposledyZvolenaUzivatelem) {

					var value: any = null;
					if (this.userSettings != null) 
						value = this.userSettings.get("epk.kposouzeni.checkbox");				

					if (value == null) 
						fields.gfield("setValue", false);
					else 
						fields.gfield("setValue", value);
				}

				if (this.EpZaskceknavy === EpkZaskceknavyEnum.Nezaskrtnuto)
					fields.gfield("setValue", false);
				if (this.EpZaskceknavy === EpkZaskceknavyEnum.Zaskrtnuto)
					fields.gfield("setValue", true);
            }
		}


	}
}

